import React from "react"
import Input from "../components/contact/input"
import Header from "../components/section/header"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { useForm } from "react-hook-form"
import { StaticImage } from "gatsby-plugin-image"
export default function Contact({ location }) {
  return (
    <Layout>
      <Seo pathname={location.pathname} title="Contact" />
      <Header
        image={
          <StaticImage
            alt="Contact"
            className="h-full w-full object-cover animate"
            src="../images/picture-1.webp"
          />
        }
        title="Contact"
      />
      <ContactForm />
    </Layout>
  )
}

const ContactForm = () => {
  const {
    register,
    handleSubmit,

    // control,
  } = useForm()

  const Submit = data => {
    return console.log(data)
  }
  return (
    <div className="py-12 md:py-20 max-w-4xl mx-auto w-11/12 xl:w-full">
      <div className="text-center space-y-2 pb-12">
        <h2 className="text-xl md:text-3xl capitalize pb-1">
          We would love to hear from you!
        </h2>
        <p className="text-teal-600 text-xs tracking-widest">
          Send us a message and we’ll get right back in touch.
        </p>
      </div>
      <form
        onSubmit={handleSubmit(Submit)}
        className="grid md:grid-cols-2 gap-2 lg:gap-6"
      >
        <Input
          name="first"
          placeholder="Enter Your First Name"
          label="Your First Name* :"
          type="text"
          register={register}
        />
        <Input
          name="last"
          placeholder="Enter Your Last Name"
          label="Your Last Name* :"
          type="text"
          register={register}
        />
        <Input
          name="email"
          placeholder="Enter Your Email"
          label="Your Email* :"
          type="email"
          register={register}
        />
        <Input
          name="phone"
          placeholder="Enter Your Phone No."
          label="Your Phone* :"
          type="text"
          register={register}
        />
        {/* <Input
          className="md:col-span-2"
          name="address"
          placeholder="Enter Your Address."
          label="Your Address* :"
          type="text"
          register={register}
        /> */}

        <Input
          className="md:col-span-2"
          TextArea
          name="message"
          label="Your Message* :"
          rows={12}
          register={register}
        />
        <div>
          <button className="px-6 py-3 rounded uppercase tracking-[0.1em] text-sm bg-stone-700  text-white outline-none focus:outline-none">
            Send
          </button>
        </div>
      </form>
      <div className="py-12 md:py-20 flex justify-center select-none">
        <span className="text-6xl uppercase tracking-[0.1em] text-stone-300 italic">
          OR
        </span>
      </div>
      <div className="py-6 md:py-12">
        <h3 className="text-center text-2xl md:text-4xl">Mail us at:</h3>
        <div className="flex justify-center">
          <a
            href="mailto:info@theorchidgroup.properties"
            className="italic font-light"
          >
            Info@theorchidgroup.properties
          </a>
        </div>
        <h3 className="text-center text-2xl md:text-4xl">Call us:</h3>
        <div className="flex justify-center">
          <a href="tel:+34 610 996 112" className="italic font-light">
            +34 610 996 112
          </a>
        </div>
      </div>
    </div>
  )
}
